import { useCallback } from 'react';

import { showAlert } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import type { FamilyEvent } from '@/features/guardian/family-events';
import { shareEvent } from '@/features/guardian/utils/share-event';
import { useGuardianStackNavigation } from '@/hooks';

const strings = STRINGS.guardian.kids.eventDetail;

/** Shared action dispatcher for every Event Detail surface. */
export function useEventDetailActions() {
  const navigation = useGuardianStackNavigation();

  const handleOpenMap = useCallback((_event: FamilyEvent) => {
    showAlert({
      title: strings.mapAlertTitle,
      message: strings.mapAlertMessage,
    });
  }, []);

  const handleShare = useCallback((event: FamilyEvent) => {
    shareEvent(event);
  }, []);

  const handleReschedule = useCallback(() => {
    // TODO(PP-510): Replace the placeholder when the reschedule flow is available.
    navigation.navigate('ComingSoon');
  }, [navigation]);

  const handleViewBooking = useCallback(
    (event: FamilyEvent) => {
      navigation.navigate('GuardianBookingDetails', {
        bookingId: event.bookingId,
        playerId: event.playerId,
      });
    },
    [navigation],
  );

  return { handleOpenMap, handleShare, handleReschedule, handleViewBooking };
}
